import { render } from "./heroComponent.vue?vue&type=template&id=2c4a952a&scoped=true"
const script = {}

import "./heroComponent.vue?vue&type=style&index=0&id=2c4a952a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4a952a"]])

export default __exports__